export const getCurrentModal = state => state?.modals?.current;

export const getCurrentModalProps = state => state?.modals?.currentProps || {};
